import { isFilledValue } from "web_myplann/Shared/Utils/isFilledValue";
import { z } from "zod";

export const REQUIRED_MINIMUM_ERROR_KEY = "requiredMinimum";

export const refineRequiredMinimum =
	<Field extends string>(fields: readonly Field[]) =>
	(data: Partial<Record<Field, unknown>>, ctx: z.RefinementCtx) => {
		if (fields.some((field) => isFilledValue(data[field]))) {
			return;
		}

		ctx.addIssue({
			code: z.ZodIssueCode.custom,
			path: [REQUIRED_MINIMUM_ERROR_KEY],
		});
	};
